import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PF2MTabs from '~/components/PF2MTabs';
import ExpediteMaterialsTab from './ExpediteMaterialsTab';
import styles from './styles';


const ExpediteMaterials = ({ classes }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Materials') },
  ];

  const handleChange = (event, value) => setSelectedTab(value);

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<ExpediteMaterialsTab />) : null}
    </>
  );
};

ExpediteMaterials.propTypes = {
  classes: PropTypes.object.isRequired,
};

ExpediteMaterials.defaultProps = {};

export default withStyles(styles)(ExpediteMaterials);
